// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1IKiu","image":"Header_image__iKAHs","name":"Header_name__1LkXG","info":"Header_info__405iM","infoRow":"Header_infoRow__2KjJF"};